<!--
  ~ Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
  ~
  ~ Please see distribution for license.
  -->

<div class="main">
  @if (tenantListLoading$ | async) {
  <div class="container__spinner">
    <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  </div>
  } @else {
  <section class="og-container">
    <div class="tenant__controls">
      <div class="tenant-filter__container">
        <input
          placeholder="Filter tenants"
          class="tenant-filter__input"
          (keyup)="onFilterKeyUp($event.target.value)"
        />
      </div>
      <a
        mat-raised-button
        class="tenant__add"
        (click)="triggerTenantCreationWizard()"
        color="primary"
      >
        <i class="material-icons">add</i>
        Add Tenant
      </a>
    </div>
    @if (showCreateTenantWizard$ | async) {
    <div class="create-wizard">
      <og-tenant-creation-wizard></og-tenant-creation-wizard>
    </div>
    }
    <h2 class="tenant-title">
      {{
        tenantFilter$.value.length === 0
          ? 'All Tenants'
          : "Tenants containing '" + tenantFilter$.value + "'"
      }}
    </h2>
    @if ((provisioningTenants$ | async)?.length) {
    <h3 class="tenant-title">
      Provisioning
    </h3>
    } @for (tenant of provisioningTenants$ | async; track tenant) {
    <div class="container__tenant">
      <mat-card appearance="outlined" class="tenant__card" (click)="onOpenDetailsClicked(tenant)">
        <a class="card__content">
          <div class="content__label">
            <span class="tenant__organisation">{{ tenant.organizationId }}</span>
            <span class="tenant__name">{{ tenant.name }}</span>
          </div>
        </a>
      </mat-card>
    </div>
    } @if ((enabledTenants$ | async)?.length) {
    <h3 class="tenant-title">
      Enabled
    </h3>
    } @for (tenant of enabledTenants$ | async; track tenant) {
    <div class="container__tenant">
      <mat-card appearance="outlined" class="tenant__card">
        <a class="card__content">
          <div class="content__label" (click)="onOpenDetailsClicked(tenant)">
            <span class="tenant__organisation">{{ tenant.organizationId }}</span>
            <span class="tenant__name">{{ tenant.name }}</span>
          </div>
          @if (canLogin(userDetails$ | async, tenant)) {
          <div class="login-button" (click)="loginToTenant(tenant)">
            <i class="material-icons">forward</i>
          </div>
          }
        </a>
      </mat-card>
    </div>
    } @if ((disabledTenants$ | async)?.length) {
    <h3 class="tenant-title">
      Disabled
    </h3>
    } @for (tenant of disabledTenants$ | async; track tenant) {
    <div class="container__tenant">
      <mat-card appearance="outlined" class="tenant__card" (click)="onOpenDetailsClicked(tenant)">
        <a class="card__content">
          <div class="content__label">
            <span class="tenant__organisation">{{ tenant.organizationId }}</span>
            <span class="tenant__name">{{ tenant.name }}</span>
          </div>
          @if (canLogin(userDetails$ | async, tenant)) {
          <button mat-raised-button color="accent" [disabled]="true" class="card__button">
            <i class="material-icons">forward</i>
          </button>
          }
        </a>
      </mat-card>
    </div>
    }
  </section>
  }
</div>
